/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

// Module to make the MediumEditor library/api injectable.
angular.module('bulbApp.contentEditorModule')
.factory('MediumEditor', ['$window', MediumEditor]);

function MediumEditor($window) {
  return $window.MediumEditor;
}
